module.exports = __webpack_public_path__ + "static/media/Analisis.d1297838.svg";